import { Points } from './breakpoints';
import { INDENT_LEVELS } from '@constants/params';

const createIndent = (property, direction, level, options) => {
  const { isMinus = false } = options;
  const values = INDENT_LEVELS[level];

  if (!values) {
    console.error(`${level} - This indent level is not available`);
    return '';
  }

  const createRule = (value) => {
    const size = isMinus ? `-${value}` : value;

    if (direction === 'top') {
      return property + `-top:${size}px;`;
    } else if (direction === 'bottom') {
      return property + `-bottom:${size}px;`;
    } else {
      return property + `-top:${size}px;` + property + `-bottom:${size}px;`;
    }
  };

  return `
    ${createRule(values[0])};
  
    @media ${Points.tablet_portrait} {
      ${createRule(values[1])};
    }
    
    @media ${Points.laptop} {
      ${createRule(values[2])};
    }

    @media ${Points.fullhd} {
      ${values[3] ? createRule(values[3]) : createRule(values[2])};
    }
  `;
};

export const paddingLevel = (direction = 'top', level = '', options = {}) => {
  return createIndent('padding', direction, level, options);
};

export const marginLevel = (direction = 'top', level = '', options = {}) => {
  return createIndent('margin', direction, level, options);
};
